<template>
  <div class="body_login" >
    <div class="body_login_logo">
      <div class="body_login_logo_item">
        <img src="https://img.aixuejie.cn/extra/showclub/5_1603682434/5_爱学界_1603682439_ee1eaddfe346bebfead92d86e04147cb.png">
      </div>
      <div class="body_login_logo_item">
        <img src="@/assets/image/axj_web/axj_web_body_icon.png">
      </div>
    </div>
    <div class="body_login_center">

    </div>
    <div class="body_login_form">
      <div class="body_login_form_title">
        <label>机构用户登录</label>
      </div>
      <div class="body_login_form_main">
        <div class="body_login_form_background">
          <img src="https://img.aixuejie.cn/extra/showclub/5_1604910793/5_爱学界_1604910814_995283d11ccea6aa1f3c7bd12e84c34b.png">
        </div>
        <div class="body_login_form_body">
          <div class="body_login_form_normal_login">
            <div class="body_login_form_normal_item">
              <div class="body_login_label">
                <label>
                  手机号码
                </label>
              </div>
              <div class="body_login_normal-input">
                <el-input @keyup.native="handlePhoneKeyUp" @keydown.native="handlePhoneKeyUp"  v-model="loginForm.phone" @input="handlePhoneInput"></el-input>
              </div>
            </div>
            <div ref="loginInputPhoneMessage" class="body_login_form_normal_message">
              <span>{{loginMessage.phone}}</span>
            </div>
            <div class="body_login_form_normal_item">
              <div class="body_login_label">
                <label>
                  密码
                </label>
              </div>
              <div class="body_login_normal-input">
                <el-input type="password" v-model="loginForm.password"></el-input>
              </div>
            </div>
            <div  class="body_login_form_normal_message">
              <span>{{loginMessage.password}}</span>
            </div>
            <div class="body_login_form_normal_item">
              <div @click="handleLogin" class="body_login_normal-button">
                <label>登录</label>
                <span>
                </span>
              </div>
              <div class="body_login_normal-forget">
                <label>忘记密码？</label>
              </div>
            </div>
          </div>
          <div class="body_login_form_line">
            <img src="@/assets/image/axj_web/axj_web_body_line.png"/>
          </div>
          <div class="body_login_form_ewm_login">
            <axj_wx_login
              @do-bind="handleBind"
              :appid="wxLoginConfig.AppId"
              :scope="wxLoginConfig.Scope"
              :theme="wxLoginConfig.Theme"
              :self_redirect="wxLoginConfig.SelfRedirect"
              class="body_login_form_ewm_login_top"
              :redirect_uri="encodeURIComponent(wxLoginConfig.RedirectUri)"
              :href="wxLoginConfig.CssBase64Href"
              :state="wxLoginConfig.state"
              @do-login="handleLogin1"
              rel="external nofollow"
            >
            </axj_wx_login>
            <div class="body_login_form_ewm_login_bottom">
              <label>微信扫码登录</label>
            </div>
          </div>
        </div>
      </div>
      <div class="body_login_form_bottom" >
        <div class="body_login_form_cer">
          <div class="body_login_form_button" @click="showLogin">
            <label>机构用户认证</label>
            <span></span>
          </div>
        </div>
      </div>
    </div>
    <axj-web-certs
      :show.sync="loginDialogConf.show"
      :title="loginDialogConf.title"
      :wxUnionId="loginDialogConf.wxUnionId"
    />
    <axj-message-prop
      :dialog-show.sync="axjMessagePropData.dialogShow"
      :button-data="axjMessagePropData.buttonData"
      :dialog-message="axjMessagePropData.dialogMessage"
      :dialog-title="axjMessagePropData.dialogTitle"
      :handle-func="axjMessagePropData.handleFunc"
    />
  </div>
</template>

<script>


import AxjMessageProp from "../../../../../../components/axj-message-prop/index";
import commonModels from '@/common/models/common-models'
export default {
  name: "body_login",
  components: {AxjMessageProp},
  data(){
    return{
      loginForm:{
        phone:'',
        password:undefined
      },
      axjMessagePropData:{
        dialogShow:false,
        buttonData:[
          {
            "label":"去认证",
            "key":"yes",
            "type":""
          },
          {
            "label":"取消",
            "key":"cancel",
            "type":"primary"
          }
        ],
        handleFunc:function (){
        },
        dialogMessage:undefined,
        dialogTitle:"提示"
      },
      loginDialogConf:{
        show:false,
        title:'账号登录',
        active:'login',
        wxUnionId:undefined
      },
      loginMessage:{
        phone:'手机号码格式不正确',
        password:'密码不能为空'
      },
      wxLoginConfig:{
        AppId:"wx7dd1288d27f109d9",
        Scope:"snsapi_login",
        Theme:"black",
        SelfRedirect:true,
        RedirectUri:"http://www.aixuejie.cn/#/cert",
        CssBase64Href:'data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDEwOHB4O2hlaWd0aDoxMDhweDttYXJnaW46MHB4O3BhZGRpbmc6MHB4fQ0KLmltcG93ZXJCb3ggLnRpdGxlIHtkaXNwbGF5OiBub25lO30NCi5pbXBvd2VyQm94IC5pbmZvIHtkaXNwbGF5Om5vbmV9DQouc3RhdHVzX2ljb24ge2Rpc3BsYXk6IG5vbmV9DQouaW1wb3dlckJveCAuc3RhdHVzIHt0ZXh0LWFsaWduOiBjZW50ZXI7fSA=',
      }
    }
  },
  methods:{
    handlePhoneKeyUp(v){
      if(v.code!='Backspace'){
        if(this.loginForm.phone.length==3||this.loginForm.phone.length==8){
          this.loginForm.phone=this.loginForm.phone+" "
        }
      }
    },
    handleBind(unionId){
      this.loginDialogConf.show=true
      this.loginDialogConf.wxUnionId=unionId
    },
    showLogin(){
      this.loginDialogConf.show=true
    },
    initUserInfo(){
      //根据vuex保存的uuid获取用户信息
      this.$api.commonApi.commonIndex.getUserInfo({uuid: this.$store.getters.getLoginInfo.uuid}).then(res => {
        if (res.code == 200) {
          this.userInfo = res.data
          this.$store.dispatch('saveLoginInfo', {
            uuid: this.$store.getters.getLoginInfo.uuid,
            access_token: this.$store.getters.getLoginInfo.access_token,
            refresh_token:this.$store.getters.getLoginInfo.refresh_token,
            userId: res.data.id
          });
          console.log("判断是否为第三方")
          //判断是否为第三方
          if (this.userInfo.is_third_party == 0) {
            console.log("不是第三方")

            this.$api.axjWebApi.webAuth.QueryMechanismAuths({
              UserId:this.userInfo.id
            }).then(res=>{
              //判断是否有提交认证审核或认证不通过
              console.log("判断是否有提交认证审核或认证不通过")
              if(res.data==null||res.data.lists.Status==2){
                //没有提交过认证审核或认证不通过
                console.log("没有提交过审核或认证不通过")
                this.axjMessagePropData.dialogShow=true
                let that=this
                this.axjMessagePropData.handleFunc=function (v) {
                  if(v==='yes'){
                    that.$router.push({
                      path:"/certification"
                    })
                  }else if('cancel'===v){
                    that.axjMessagePropData.dialogShow=false
                  }
                }
                this.axjMessagePropData.dialogMessage="尊敬的 "+this.userInfo.nickname+"，您尚未进行机构用户认证，无法使用机构用户管理平台，是否去认证？"
              }else if (res.data.lists.Status==0){
                console.log("有提交认证,没有审核")
                this.axjMessagePropData.buttonData=[{
                  "label":"取消",
                  "key":"cancel",
                  "type":"primary"
                }]
                let that=this
                this.axjMessagePropData.handleFunc=function (res) {
                  if(res==='cancel'){
                    that.axjMessagePropData.dialogShow=false
                  }
                }
                this.axjMessagePropData.dialogShow=true
                this.axjMessagePropData.dialogMessage="尊敬的 "+this.userInfo.nickname+"您已于"+commonModels.formatTime(res.data.lists.CreateTime,'Y年M月D日')+"提请机构用户认证，平台会在7个工作日内完成审核，请您耐心等待！"
              }
            })
          }else{
            console.log("第三方")
            this.$store.dispatch("saveUser",
              {
                uid:this.userInfo.id,
                uname:this.userInfo.nickname,
                avatar:this.userInfo.avatar,
                extraShowClubUid:this.userInfo.ExtraShowclubUser.id,
                schoolId:this.userInfo.school_id,
                infoUserUid:this.userInfo.InfoUser.id,
                info:this.userInfo
              })
            this.$router.push({
              path:"/axjMain"
            })
          }
        }
      })
    },
    handleLogin1(res){
      if(res.code==200){
        this.initUserInfo()
      }
    },
    handleLogin(){
      let form=this.loginForm
      this.$api.commonApi.commonIndex.doLogin({
        identifier:form.phone.replace(/[^\d]/g,""),
        credential:form.password,
        type:"username",
        device:'pc'
      }).then(res=>{
        if(res.code==200){
          this.initUserInfo()
        }else{
          this.$message({
            type:"error",
            message:"手机号或密码错误"
          })
        }
      },error => {
        this.$message({
          type:"error",
          message:"手机号或密码错误"
        })
      })
    },
    handlePhoneInput(v){
      let lastInput=v.substring(v.length-1,v.length)
      if(isNaN(lastInput)){
        this.loginForm.phone=v.substring(0,v.length-1)
      }
      if(this.loginForm.phone.length>13){
        this.loginForm.phone=this.loginForm.phone.substr(0,13);
      }
      let reg=/^1[3456789]\d{9}$/;
      if(this.loginForm.phone.length>=13){
        if(!reg.test(this.loginForm.phone.replace(/[^\d]/g,""))){
          this.$refs.loginInputPhoneMessage.style.visibility='visible'
        }else{
          this.$refs.loginInputPhoneMessage.style.visibility='hidden'
        }
      }
    }

  }
}
</script>

<style slot-scope lang="scss">
.body_login{
  height: 100%;
  display: flex;
  .body_login_logo{
    width: 556px;
    flex: 27.5;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: flex-end;
    .body_login_logo_item:not(:last-child){
      margin-top: 10px;
      img{
        width: 125.25px;
        height: 125.6px;
      }
    }
    .body_login_logo_item:not(:first-child){
      width: 125.25px;
      display: flex;
      justify-content: center;
      margin-top: 20.42px;
      img{
        width: 106.5px;
        height: 26.3px;
      }
    }
  }
  .body_login_center{
    flex:15.5
  }
  .body_login_form{
    flex: 100-15.5-27.5;
    display: flex;
    flex-flow: column;
    justify-content: center;
    .body_login_form_title{
      display: flex;
      label{
        width: 654px;
        font-family: Source Han Sans CN;
        font-style: normal;
        font-weight: normal;
        font-size: 21px;
        line-height: 41px;
        /* identical to box height */
        letter-spacing: 0.13em;
        color: rgba(244, 244, 244, 0.5);
      }

    }
    .body_login_form_main{
      display: flex;
      margin-top: 5.6px;
      .body_login_form_background{
        height: 262.26px;
        img{
          width: 654px;
          height: 262.26px;
        }
        background: rgba(2, 3, 27, 0.4);
      }
      .body_login_form_body{
        position: absolute;
        width: 654px;
        height: 262.26px;
        display: flex;
        .body_login_form_normal_login{
          flex: 59.9;
          .body_login_form_normal_message{
            margin-left: 135.85px;
            align-items: center;
            font-size: 12px;
            color: red;
            display: flex;
            height: 35.7px;
            visibility: hidden;
          }
          .body_login_form_normal_item{
            margin-left: 50.85px;
            display: flex;
            //margin-top: 35.7px;
            .body_login_label{
                display: flex;
                align-items: center;
                width: 78px;
                height: 29.2px;
                font-family: Source Han Sans CN;
              justify-content: center;
                label{
                  text-align: justify;
                  text-align-last: justify;
                  width: 60px;
                }
                font-style: normal;
                font-weight: normal;
                font-size: 15px;
                line-height: 29px;
                color: rgba(255, 255, 255, 0.5);
            }
            .body_login_normal-input{
              margin-left: 7px;
              .el-input__inner{
                padding: 0;
                padding-left: 5px;
              }
              input{
                outline-color: invert;
                outline-style: none;
                outline-width: 0px;
                border: none;
                border-style: none;
                text-shadow: none;
                -webkit-appearance: none;
                -webkit-user-select: text;
                outline-color: transparent;
                box-shadow: none;

                color: #ffffff;
                font-size: 13px;
                height: 35.8px;
                width: 189.75px;
                background:none;
                outline:none;
                border:none;
                background: rgba(255, 255, 255, 0.2) !important;
                box-shadow: inset 3px 2px 4px rgba(0, 0, 0, 0.25) !important;
                border-radius: 4px;

              }
            }

          }
          .body_login_form_normal_item:last-child{
            display: flex;
            .body_login_normal-button{
              margin-left: 7px;
              cursor: pointer;
              width: 161.3px;
              height: 47.49px;
              background: linear-gradient(276.5deg, rgba(0, 0, 0, 0.55) 0%, rgba(0, 0, 0, 0) 100%), rgba(255, 0, 0, 0.6);
              box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
              border-radius: 4px;
              display: flex;
              align-items: center;
              justify-content: center;
              label{
                cursor: pointer;
                font-family: Source Han Sans CN;
                font-style: normal;
                font-weight: normal;
                font-size: 18px;
                /* identical to box height */
                letter-spacing: 1.1em;
                color: #FFFFFF;
              }
              span{
                width: 10.05px;
                height: 10.05px;
                border-top: 3px solid #fff;
                border-radius: 2px;
                border-left: 3px solid #fff;
                transform: rotate(135deg);
              }
            }
            .body_login_normal-forget{
              display: flex;
              align-items: center;
              margin-left: 40px;
              font-family: Source Han Sans CN;
              font-style: normal;
              font-weight: normal;
              font-size: 15px;
              line-height: 29px;
              /* identical to box height */
              color: #0075FF;
            }
          }
          .body_login_form_normal_item:first-child{
            margin-top: 43px;
          }
        }
        .body_login_form_line{
          height: 100%;
          display: flex;
          align-items: center;
          img{
            height: 194px;
          }
        }
        .body_login_form_ewm_login{
           flex: 100-59.9;
          display: flex;
          flex-flow: column;
          align-items: center;
          justify-content: center;
          .body_login_form_ewm_login_top{
            width: 108px;
            height: 108px;
            margin-top: 12px;
           // background-color: #13ce66;
          }
          .body_login_form_ewm_login_bottom{
            margin-top: 26px;
            label{
              font-family: Source Han Sans CN;
              font-style: normal;
              font-weight: normal;
              font-size: 18px;
              line-height: 35px;
              /* identical to box height */
              letter-spacing: 0.13em;
              color: #FFFFFF;
            }
          }
        }
      }
    }
    .body_login_form_bottom{
      display: flex;
      .body_login_form_cer{
        width: 654px;
        .body_login_form_button,label:hover{
          cursor: pointer;
        }
        .body_login_form_button{
          width: 277.5px;
          display: flex;
          align-items: center;
          height: 51.86px;
          background: linear-gradient(91.44deg, rgba(0, 0, 0, 0) 0%, rgba(9, 9, 9, 0.0071875) 0.01%, rgba(9, 9, 9, 0) 0.02%, rgba(0, 0, 0, 0.4) 99.96%), rgba(0, 117, 255, 0.4);
          border-radius: 4px;
          margin-top: 40px;
          justify-content: center;
          label{
            font-family: Source Han Sans CN;
            font-style: normal;
            font-weight: normal;
            font-size: 18px;
            line-height: 36px;
            /* identical to box height */

            letter-spacing: 0.3em;

            color: #FFFFFF;

            text-shadow: 0px 0px 4px #000000;
          }
          span{
            width: 12.05px;
            height: 12.05px;
            margin-left: 20px;
            border-top: 3px solid #fff;
            border-radius: 2px;
            border-left: 3px solid #fff;
            transform: rotate(135deg);
          }
        }
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/views/axj_web/component/web_body/component/body_login/index.vue